<template>
    <div>
        <BoardSection
            v-for="section in sections"
            :key="section.id"
            :faq="faq"
            :section="section"
            :query="query"
        />
    </div>
</template>

<script>
import BoardSection from "./BoardSection.vue";

export default {
    name: "BoardLayout",
    props: {
        faq: Object,
        sections: Array,
        query: String,
    },
    components: {
        BoardSection,
    },
};
</script>
